import React from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import ErrorPage from 'next/error';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import StartNow from '../../components/organisms/StartNow';
import ComparisonMain from '../../components/Service/Comparison';
import { prismicApi } from '../../utils/prismicApi';
import { useTranslation } from 'next-i18next';

interface Props {
  post: any;
}

export default function Post({ post }: Props) {
  const router = useRouter();
  const { locale } = router;
  useTranslation('common');
  if (!post) {
    return <ErrorPage statusCode={404} />;
  }
  if (locale !== 'ja') {
    return <ErrorPage statusCode={404} />;
  }
  return (
    <article>
      <Head>
        <title>{post.title[0].text} | オンライン英会話のリンガルボックス</title>
        <meta property="og:image" content={post.featured_image.url} />
      </Head>
      <ComparisonMain post={post} />
      <StartNow />
    </article>
  );
}

export async function getStaticProps({ params, locale }) {
  try {
    const data = await prismicApi.fetchByUid(`${params.slug}-ja-jp`, 'ja-jp');
    return {
      props: {
        ...(await serverSideTranslations(locale, ['common', 'blog'])),
        post: typeof data === 'undefined' ? null : data.data,
      },
    };
  } catch (e) {
    return {
      props: {
        ...(await serverSideTranslations(locale, ['common', 'blog'])),
        post: null,
      },
    };
  }
}

export async function getStaticPaths() {
  const slugs = [
    'language-exchange',
    'offline-english-school',
    'learn-in-the-philippines',
    'online-school-vs-english-bootcamp',
    'tickets-vs-daily',
    'one-to-one-vs-group',
    'personal-tutor-vs-online-school',
  ];
  // Only generate paths for Japanese locale since this page is ja-only
  const paths = slugs.map((slug) => ({
    params: { slug },
    locale: 'ja',
  }));
  return {
    paths,
    fallback: false,
  };
}
